import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";
import Colors from "../../Colors";

const FULL_OPAC = Colors.B_GREY_4;
const NO_OPAC = Colors.B_GREY_2;
export const FootstepParticle = {
  mode: ParticleModes.DRAW_APPEND,
  char: ".",
  fg: FULL_OPAC,
  bg: "transparent",
  animate: async (particle: Particle<void>) => {
    await awaitAnimate({
      driver: particle.driver,
      from: FULL_OPAC,
      to: NO_OPAC,
      duration: 300,
      onUpdate: (latest) => {
        particle.fg = latest;
      },
    });
  },
};
